import { AxiosResponse } from 'axios';

import { analyticsClient } from './api';

export interface ShareTargetDto {
  username: string;
  displayName: string;
}

export interface ShareTargetsResponse {
  users: ShareTargetDto[];
}

/**
 * Share-target search bound to GET /api/v1/dashboards/share-targets.
 * Results are server-scoped to the caller's own realm and tenant; the response carries
 * username + displayName only. Requires a dashboard mutation role (viewers get 403).
 */
export const userDirectoryApi = {
  searchShareTargets: async (q: string): Promise<ShareTargetDto[]> => {
    const response: AxiosResponse<ShareTargetsResponse> = await analyticsClient.get(
      '/api/v1/dashboards/share-targets',
      { params: { q } }
    );
    return response.data?.users ?? [];
  },
};
